export const timezone = "Europe/Berlin";
